<template>
  <Form>

    <div class="text-center py-5 px-5">
      <h4>Redefina sua senha</h4>
    </div>

    <div class="input-group pb-3">
      <span class="input-group-text"><LockIcon/></span>
      <input v-model="password" placeholder="Sua senha"
             :type="showPassword ? '' : 'password'"
             class="form-control input"
             autocomplete="new-password"
             aria-describedby="passwordHelp"/>
      <i class="eye-password" @click="showPassword = !showPassword"
         :title="showPasswordConfirmation ? 'Ocultar Senha' : 'Mostrar Senha'">
        <EyeIcon v-if="showPassword"/>
        <EyeOffIcon v-else/>
      </i>
    </div>

    <div class="input-group">
      <span class="input-group-text"><LockIcon/></span>
      <input v-model="passwordConfirmation" placeholder="Confirmar senha"
             :type="showPasswordConfirmation ? '' : 'password'"
             class="form-control input"
             autocomplete="new-password"
             aria-describedby="passwordHelp"/>
      <i class="eye-password" @click="showPasswordConfirmation = !showPasswordConfirmation"
         :title="showPasswordConfirmation ? 'Ocultar Senha' : 'Mostrar Senha'">
        <EyeIcon v-if="showPasswordConfirmation"/>
        <EyeOffIcon v-else/>
      </i>
    </div>

    <div class="form-group pb-5">
      <div class="row">
        <div id="sign-up" class="btn-group col-md-12 mt-3">
          <button @click="send()" :disabled="disableButtonSend" class="btn btn-primary">Enviar</button>
        </div>
      </div>

      <div class="row">
        <div id="sign-in" class="btn-group col-md-12 mt-3">
          <button @click="sendLogin()" class="btn btn-link">Voltar</button>
        </div>
      </div>
    </div>

  </Form>
</template>

<script>
  import Form from '@/components/auth/Form'
  import { EyeIcon, EyeOffIcon, LockIcon } from 'vue-feather-icons'

  export default {
    components: { EyeIcon, EyeOffIcon, Form, LockIcon },
    computed: {
      disableButtonSend() {
        return !(this.password && this.passwordConfirmation)
      },
    },
    created() {
      localStorage.removeItem('authHeaders')

      if (this.$utilUri.getQuery()['expired']) {
       this.$router.push('/login')
       this.$notify.add('Seu token expirou!', {
         closingTime: 10000,
         type: 'error'
       })
      }
    },
    data() {
      return {
        password: '',
        passwordConfirmation: '',
        showPassword: false,
        showPasswordConfirmation: false
      }
    },
    methods: {
      send() {
        const data = {
          password: this.password,
          password_confirmation: this.passwordConfirmation
        }
        
        const headers = this.$utilUri.getQuery()
        this.axios.put('auth/password', data, { headers: headers })
          .then(response => this.$notify.add(response.message))
          .then(() => this.$router.push('login'))
          .catch(e => this.$notify.addError(e))
      },
      sendLogin() {
        this.$router.push('login')
      }
    },
    name: 'ResetPassword'
  }
</script>

<style scoped>

.eye-password {
  position: absolute;
  top: 8px;
  right: 13px;
  cursor: pointer;
  z-index: 5;
}

</style>
